import { Component, Input } from '@angular/core';
import { trackByRef } from 'src/app/lego-utils';
import { ItemRevisionDataset } from 'src/app/models/domain';

@Component({
  selector: 'em-item-revision-dataset-table',
  styleUrls: ['./item-revision-dataset-table.component.less'],
  templateUrl: './item-revision-dataset-table.component.html',
  standalone: false,
})
export class ItemRevisionDatasetTableComponent {
  @Input() public data: ItemRevisionDataset[] = [];
  @Input() public errorMsg: string | undefined;
  @Input() public loading = false;
  public readonly trackByRef = trackByRef;

  public onIconClick({ link }: ItemRevisionDataset) {
    window.open(link);
  }
}
